import Vue from 'vue'
const bus = new Vue({
    name: 'bus',
    data() {
      return {}
    }
  }
);
export default bus



// WEBPACK FOOTER //
// ./src/libs/bus.js